import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { URL, SPORTS_CATEGORY, INTERVAL_TIME, DATASET_TYPE_CATEGORY, Logo, DEV_API } from '../../const/index.js';

import SocrePlayBoard from './play';
import { SlideProvider } from './SlideContext';


function EventComponent(props) {
    const { primaryColor, secondaryColor, tabStatus, sportCategory, eventId, team1Idx, startPos, editPrimaryTeam, closetScorePair, playerNames, player1Name, player2Name, player3Name, player4Name, isDemo, handleTeamName, isFree, payout, point } = props;

    const [events, setEvents] = useState([]);
    const [playList, setPlayList] = useState([]);
    const [intervalTime, setIntervalTime] = useState(3);

    const [gameId, setGameId] = useState('');
    // const [eventId, setEventId] = useState(-1);
    // const [sportCategory, setSportCategory] = useState('NFL');

    const [time, setTime] = useState();
    const [team2Name, setTeam2Name] = useState('');
    const [selTeamIdx, setSelTeamIdx] = useState(-1);

    const [increaseAmt, setIncreaseAmt] = useState(false);
    const [homeScore, setHomeScore] = useState(0);
    const [awayScore, setAwayScore] = useState(0);

    const [selTextIdx, setSelTextIdx] = useState(0);
    const [selTblIdx, setSelTblIdx] = useState(0);
    const [description, setDescription] = useState('');

    const [historyList, setHistoryList] = useState([[], [], [], []]);
    const [timeList, setTimeList] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [resultList, setResultList] = useState([]);

    // winProbability
    const [winProbability, setWinProbability] = useState();

    const [turns, setTurns] = useState(1);

    const [selectedTeamTime, setSelectedTeamTime] = useState(0);
    const [startTime, setStartTime] = useState(-1);

    const [tableScore, setTableScore] = useState([0, 0, 0, 0]);

    const [isLoading, setIsLoading] = useState(true);

    /* Tab Index */
    const [goIndex, setGoIndex] = useState(0);


    const [selectedTeam1s, setSelectedTeam1s] = useState([0, 0, 0, 0]);

    useEffect(() => {
        setSelectedTeam1s([team1Idx, team1Idx, team1Idx, team1Idx])

        if (sportCategory == 'NBA3') {
            setIntervalTime(20);
        }
    }, [])

    /* Get Total Event */
    useEffect(() => {
        let apiUrl = URL[sportCategory + '_TODAY_EVENT'];

        axios.get(apiUrl,
        ).then((response) => {
            setEvents(response.data.events);
        }).catch((err) => {
            console.log(err);
        });
    }, [sportCategory])

    /* Get Event List */
    useEffect(() => {
        if (eventId != -1) {
            if (startTime != -1) {
                // goToPlay()
            } else {
                const interval = setInterval(() => {
                    fetchEventPlay();
                }, intervalTime * 1000);
                return () => clearInterval(interval);
            }
        } else {
            setPlayList([])
        }
    }, [eventId, intervalTime, team1Idx, sportCategory, startTime])

    const fetchEventPlay = () => {
        axios.post(`${DEV_API}/api/getCheckedDS`, {
            event: eventId,
            team1Idx,
            sportCategory,
        }).then((response) => {
            console.log(response.data, 'response')

            setSelTeamIdx(response.data.selectedTeamIdx)
            setTableScore(response.data.score);
            setSelTextIdx(response.data.textIndex);
            setSelTblIdx(response.data.tableIndex);
            setIncreaseAmt(response.data.increaseAmount);
            setDescription(response.data.description);
            setTime(response.data.sequenceTime);
            setHistoryList(response.data.hisList);
            // winProbabilityData
            setWinProbability(response.data.winProbabilityData);

            setPlayList(response.data.playList)
            // prevHisList = response.data.hisList;

            setEventList(response.data.matchEvtList);
            setResultList(response.data.resultList);

            setHomeScore(response.data.homeScore);
            setAwayScore(response.data.awayScore);

            setIsLoading(false);
            if (startTime == -1) {
                setTimeList(response.data.timerList);
            }
        }).catch((error) => {
            console.error('Error fetching event data:', error);
            setIsLoading(false);
            // Handle the error gracefully - you might want to show a user-friendly message
            // or retry the request after a delay
        });
    }

    return (
        <>
            <SlideProvider>
            <SocrePlayBoard
                // tabStatus={tabStatus}
                eventId={eventId}
                team1Idx={team1Idx}
                playList={playList}
                awayScore={awayScore}
                homeScore={homeScore}
                time={time}
                tableScore={tableScore}
                selTblIdx={selTblIdx}

                DSList={resultList}
                sportCategory={sportCategory}
                winProbability={winProbability}
                startPos={startPos}

                closetScorePair={closetScorePair}
                playerNames={playerNames}
                player1Name={player1Name}
                player2Name={player2Name}
                player3Name={player3Name}
                player4Name={player4Name}

                primaryColor={primaryColor}
                secondaryColor={secondaryColor}

                isFree={isFree}
                isLoading={isLoading}
                editPrimaryTeam={editPrimaryTeam}
                payout={payout}
                point={point}

                handlePlayName={handleTeamName}
            // handlePlayerTeam1s={handlePlayerTeam1s}
            />
            </SlideProvider>
        </>
    );
}

export default EventComponent;
